import { cn } from '@/lib/cn';

/** Marca da Central: o gradiente Aptum em bloco, com o nome ao lado. */
export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <div
        className="grid h-6 w-6 flex-none place-items-center rounded gradient-primary"
        aria-hidden
      >
        <span className="text-[11px] font-bold text-white">C</span>
      </div>
      {!compact ? (
        <div className="min-w-0 leading-tight">
          <div className="truncate text-[13px] font-semibold">Central</div>
          <div className="truncate text-[10px] opacity-50">Aptum</div>
        </div>
      ) : null}
    </div>
  );
}
